export default __webpack_public_path__ + "static/media/global.356a9296.svg";